import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../App.css';
import { Constants } from "../../constants";
import GuestSiteMenu from "../guest_menu";
import SiteMenu from "../menu";
import moment from 'moment';

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY h:mm A');
}

class ManageBuildingLocation extends React.Component {
    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        let buildingExists = false;
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            location: [],
            buildings: [],
            buildingSelected: [],
            buildingSelectedIds: [],
            requestSelected:[],
            requestSelectedIds: [],

            modalText: '',
            showModal: false,
            loading: false,
            submitValue: '',
            unmappedData:[],


            search: {
                buildingName: '',
                customerID: '',
                address: '',
                state: '',
                zip: ''
            },
            showCreateModal: false,
            newBuilding: {
                BuildingName: '',
                BuildingType: 'Healthcare',
                Address: '',
                City: '',
                State: 'DC',
                Zip: '',
            },

            SubmittedMapping_BuildingName: '',
            SubmittedMapping_BuildingType: '',
            SubmittedMapping_Address: '',
            SubmittedMapping_City: '',
            SubmittedMapping_State: '',
            SubmittedMapping_Zip: '',

            page: buildingExists ? props.buildings.location.state.page : 1,
            totalSize: 20,
            sizePerPage: 10,
            showMapBuildingButton:false,
            showCreateBuildingButton: true,

        };

        this.showButton = this.showButton.bind(this);

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleMapToSelectedBuilding = this.handleMapToSelectedBuilding.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.searchBuildings = this.searchBuildings.bind(this);


        //this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCreateNew = this.handleCreateNew.bind(this);
        this.handleBuildingSelect = this.handleBuildingSelect.bind(this);
        this.handleCreateClose = this.handleCreateClose.bind(this);
        this.handleCreateSubmit = this.handleCreateSubmit.bind(this);
        this.handleNewBuildingChange = this.handleNewBuildingChange.bind(this);
        this.handleMapSubmit = this.handleMapSubmit.bind(this);
        this.MapBuildingButton = this.MapBuildingButton.bind(this);
        this.CreateBuildingDialog = this.CreateBuildingDialog.bind(this);
        this.handleAutoMapping = this.handleAutoMapping.bind(this);
        this.getUnmappedLocations = this.getUnmappedLocations.bind(this);
    }

    componentDidMount() {
        //this.searchBuildings();
        this.getUnmappedLocations();
    }
    handleRequestSelect = (row, isSelect) => {
        let selected = [];
        if (isSelect) {
            selected = [row];
        } else {
            selected = this.state.requestSelected = [];
        }

        this.setState(() => ({
            requestSelected: selected,
            requestSelectedIds: selected.map(r => r.PortalServiceRequestKey)
        }));
    }

    getUnmappedLocations() {
        axios.get(`${Constants.apiURL}/api/Request/GetUnmappedLocations`, {
            params: {
                user: this.state.user.username
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    unmappedData: response.data,
                    unmappedLoading: false,
                    location: response.data[0]
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    MapBuildingButton() {
        if (!this.state.showCreateModal) {

            return <div> <Button id="idButtonMapBuilding" disabled={!this.state.showMapBuildingButton} style={{ backgroundColor: '#00973A', marginRight: '10px', width: '204px', enabled: 'false' }} variant="primary" onClick={this.handleMapToSelectedBuilding}>
                Map To Selected Building
            </Button>
            <Button id="idButtonCreateBuilding" disabled={this.state.showMapBuildingButton} style={{ backgroundColor: '#1F419B', marginRight: '10px', width: '204px' }} variant="primary" type="submit" onClick={this.handleCreateNew}>
                Create New Building
                </Button>
            </div>
        }
    }

    CreateBuildingDialog() {
        if (this.state.showCreateModal) {
            this.state.newBuilding.BuildingName = this.state.location.LocationName;
            this.state.newBuilding.Address = this.state.location.Address1;
            this.state.newBuilding.City  = this.state.location.City ;
            this.state.newBuilding.State = this.state.location.State;
            this.state.newBuilding.Zip = this.state.location.Zip;
            let buildingName = this.state.location.LocationName;
            return <div>
                <div id="divCreateNewBuilding" style={{ border: '2px solid darkblue' }}>
                <div style={{ height: '40px', fontSize: '24px', verticalAlign:'center', textAlign: 'center', fontFamily: 'Arial', backgroundColor: '#1F419B', color: '#FFFFFF', width: '100%' }}>
                    New Building Creation
                </div >
               
                    <Form onSubmit={this.handleCreateSubmit} noValidate style={{ border: '1px', maxWidth: '800px' }} >
                        <Row className="form-row-first">
                            <Col md>
                                <Form.Group className="mb-3" controlId="formFirstname" >
                                    <Form.Label>Building Name</Form.Label>
                                    <Form.Control type="input" value={this.state.newBuilding.BuildingName} style={{ minWidth: "200px" }} />
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="formLastname">
                                    <Form.Label>Building Type</Form.Label>
                                    <Form.Select onChange={this.handleNewBuildingChange} name="BuildingType" value={this.state.newBuilding.BuildingType}>
                                        <option value="Healthcare">Healthcare</option>
                                        <option value="K-12 education">K-12 education</option>
                                        <option value="Higher education">Higher education</option>
                                        <option value="Federal government">Federal government</option>
                                        <option value="Local government">Local government</option>
                                        <option value="Commercial real estate">Commercial real estate</option>
                                        <option value="Indoor agriculture">Indoor agriculture</option>
                                        <option value="Industrial">Industrial</option>
                                        <option value="Residential">Residential</option>
                                        <option value="Retail">Retail</option>
                                        <option value="Hospitality">Hospitality</option>
                                        <option value="Data centers">Data centers</option>
                                        <option value="Public assembly">Public assembly</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="form-row-secondary">
                            <Col md>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control name="Address"  value={this.state.newBuilding.Address} onChange={this.handleNewBuildingChange} />
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="formPhoneNumber">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control name="City"  value={this.state.newBuilding.City} onChange={this.handleNewBuildingChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="form-row-secondary">
                            <Col md>
                                <Form.Group className="mb-3" controlId="formFirstname" >
                                    <Form.Label>State</Form.Label>
                                    <Form.Select onChange={this.handleNewBuildingChange} name="State"  value={this.state.newBuilding.State}>
                                        <option value="DC">DC</option>
                                        <option value="MD">MD</option>
                                        <option value="VA">VA</option>
                                        <option value="PA">PA</option>
                                        <option value="WV">WV</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md>
                                <Form.Group className="mb-3" controlId="formLastname">
                                    <Form.Label>Zip</Form.Label>
                                    <Form.Control type="input" name="Zip"  value={this.state.newBuilding.Zip} onChange={this.handleNewBuildingChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="form-row-secondary">
                            <Col md>
                                <Button variant="secondary" name="cancel" onClick={this.handleCreateClose}>
                                    Cancel
                                </Button>&nbsp;
                            </Col>
                            <Col md>
                                <Button variant="primary" name="confirm" onClick={this.handleCreateSubmit}>
                                    Confirm
                                </Button>
                            </Col>
                        </Row>   
                    </Form>
                </div>
            </div>
        }
    }

    handleTableChange() { }
    searchBuildings() {
        axios.get(`${Constants.apiURL}/api/Request/SearchBuildings`, {
            params: {
                user: this.state.user.username,
                requestID: '' //this.state.location.PortalServiceRequestKey
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    requestEquipment: response.data,
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    handleFormChange(event) {
        let search = this.state.search;
        search[event.target.name] = event.target.value;

        this.setState({
            search
        });
    }

    handleSearch(e) {
        e.preventDefault();
        document.getElementById("divBuildingList").style.display = 'block';
        this.setState(() => ({
            showCreateModal: false
        }));

        axios.get(`${Constants.apiURL}/api/Request/SearchBuildings`, {
            params: {
                user: this.state.user.username,
                buildingName:this.state.search.BuildingName,
                customerID: this.state.search.CustomerID,
                address: this.state.search.Address,
                state: this.state.search.State,
                zip: this.state.search.Zip
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    buildings: response.data
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }
    componentDidUpdate(event) {
        if (event.history.location.state && event.location.state.typeofrequest != event.history.location.state.typeofrequest) {
            let input = this.state.input;
            input.typeOfRequest = event.history.location.state.typeofrequest;
            this.setState({ input: input });
        }
    }

    handleConfirmSubmit(event) {
        event.preventDefault();
        axios.get(`${Constants.apiURL}/api/Request/MapLocation`, {
            params: {
                user: this.state.user.username,
                requestID: this.state.location.PortalServiceRequestKey,
                value: this.state.submitValue
            }
        }).then(response => {
            if (response.data) {
                this.props.history.push({
                    pathname: '/concierge_main',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert('Failed to complete/reject service request.');
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response], showModal: false })
            alert('Failed to complete/reject service request.');
            console.log('request failed', response)
        });

    }
    handleMapToSelectedBuilding(event) {
        if (this.state.buildingSelected[0] == null) {
            alert('please select a building. ');
            return;
        }
        //var confirmation = `Mapping K2A Location ${this.state.location.LocationID.trim()}/${this.state.location.LocationName.trim()} at ${this.state.location.Address1.trim()} to ${this.state.buildingSelected[0].BuildingName.trim()} with an address of ${this.state.buildingSelected[0].Address.trim()} ${this.state.buildingSelected[0].City.trim()} ${this.state.buildingSelected[0].State.trim()}, ${this.state.buildingSelected[0].Zip.trim()}`;
        var confirmation = `${this.state.buildingSelected[0].BuildingName.trim()}^${this.state.buildingSelected[0].Address.trim()}^${this.state.buildingSelected[0].City.trim()}^${this.state.buildingSelected[0].State.trim()}^${this.state.buildingSelected[0].Zip.trim()}`;
        let BuildingName = `${this.state.buildingSelected[0].BuildingName.trim()}`;
        //let BuildingType = `${this.state.buildingSelected[0].BuildingType.trim()}`; 
        let Address =   `${this.state.buildingSelected[0].Address.trim()}`;     
        let City =      `${this.state.buildingSelected[0].City.trim()}`;        
        let State =     `${this.state.buildingSelected[0].State.trim()}`;             
        let Zip =       `${this.state.buildingSelected[0].Zip.trim()}`; 
            
        this.setState({
            showModal: true,
            modalText: confirmation,
            SubmittedMapping_BuildingName: BuildingName   ,
        //    SubmittedMapping_BuildingType: BuildingType   ,
            SubmittedMapping_Address:      Address       ,
            SubmittedMapping_City:         City          ,
            SubmittedMapping_State:        State         ,
            SubmittedMapping_Zip:          Zip           ,
       });
    }
    handleMapSubmit() {
        axios.get(`${Constants.apiURL}/api/Request/MapBuilding`, {
            params: {
                user: this.state.user.username,
                locationID: this.state.location.DistinctId,
                buildingKey: this.state.buildingSelected[0].BuildingKey
            }
        }).then(response => {
            this.setState({ showCreateModal: false });
            this.props.history.push({
                pathname: '/concierge_main',
                state: { user: this.state.user }
            });
            alert('Successfully mapped location and building');
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response], showModal: false })
            alert('Failed to create building.');
            console.log('request failed', response)
        });
    }

    handleCreateNew() {
        this.setState({ showCreateModal: true });
        document.getElementById("divBuildingList").style.display = 'none';
    }
    handleCreateSubmit(event) {
        console.log(this.state.newBuilding);
        for (const prop in this.state.newBuilding) {
            if (this.state.newBuilding[prop] == '') {
                alert('Please fill in all fields');
                return;
            }

        }
        axios.get(`${Constants.apiURL}/api/Request/CreateBuilding`, {
            params: {
                user: this.state.user.username.trim(),
                address: this.state.newBuilding.Address.trim(),
                city: this.state.newBuilding.City.trim(),
                state: this.state.newBuilding.State.trim(),
                zip: this.state.newBuilding.Zip.trim(),
                buildingName: this.state.newBuilding.BuildingName.trim(),
                buildingType: this.state.newBuilding.BuildingType.trim()
            }
        }).then(response => {
            if (response.data) {
                alert(response.data);
            }
            else {
                this.setState({ showCreateModal: false });
                this.searchBuildings();
                alert('Successfully created building');
            }
            this.setState({ showCreateModal: false });
            document.getElementById("divBuildingList").style.display = 'block';
        }).catch((response) => {
                if (response.response.status === 401) {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
            // ? Show to user that request is failed
            this.setState({ errors: [response], showModal: false })
            alert('Failed to create building.');
            console.log('request failed', response)
        });
    }
    handleAutoMapping(e) {
        this.state.search.Address = this.state.location.Address1.trim();
        this.state.search.State = this.state.location.State.trim();
        this.state.search.Zip = this.state.location.Zip.trim();
        e.preventDefault();
        document.getElementById("divBuildingList").style.display = 'block';
        this.setState(() => ({
            showCreateModal: false
        }));

        axios.get(`${Constants.apiURL}/api/Request/SearchBuildings`, {
            params: {
                user: this.state.user.username,
                buildingName: this.state.location.LocationName.trim(),
                customerID: this.state.location.CustomerID.trim(),
                address: this.state.location.Address1.trim(),
                state: this.state.location.State.trim(),
                zip: this.state.location.Zip.trim(),
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    buildings: response.data
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    handleCreateClose() {
        this.setState({ showCreateModal: false });
        document.getElementById('divCreateNewBuilding').style.display = 'none';
        document.getElementById("divBuildingList").style.display = 'block';
    }

    handleClose() {
        this.setState({ showModal: false });
    }
    handleValueChange(event) {
        console.log(event.target);
        this.setState({
            submitValue: event.target.value
        });
    }
    handleBuildingSelect = (row, isSelect) => {
        let selected = [];
        console.log(row);
        console.log(isSelect);
        console.log(this.state.buildingSelected);
        if (isSelect) {
            selected = [row];
        } else {
            selected = this.state.buildingSelected = [];
        }

        this.setState(() => ({
            buildingSelected: selected,
            buildingSelectedIds: selected.map(r => r.BuildingKey),
            showMapBuildingButton: isSelect,
        }));
    }
    handleNewBuildingChange(event) {
        console.log(event);
        var newBuilding = this.state.newBuilding;
        newBuilding[event.target.name] = event.target.value;
        this.setState({ newBuilding });
    }

    render() {
        const defaultSorted = [{
            dataField: 'Address',
            order: 'asc'
        }];
        const customStyle = {
            padding: '10px',
            margin: '10px',
            maxWidth: '480px'
        };

        const buildingColumns = [
            {
                text: 'Building Name',
                dataField: 'BuildingName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: 'auto' };
                }
            },
            {
                text: 'Address',
                dataField: 'Address',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: 'auto' };
                }
            },
            {
                text: 'City',
                dataField: 'City',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all', width: 'auto' };
                }
            },
            {
                text: 'State',
                dataField: 'State',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' ,width:'60px'};
                }
            },
            {
                text: 'Zip',
                dataField: 'Zip',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all', width: '80px' };
                }
            }];

        const { buildings, showModal, buildingSelectedIds, unmappedData, requestSelectedIds, unmappedSelectedIds,buildingSelected, showCreateModal, page, totalSize, sizePerPage } = this.state;
        //const { requestData, unmappedData, requestSelected, unmappedSelected, requestSelectedIds, unmappedSelectedIds } = this.state;

        const selectBuildingRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleBuildingSelect,
            hideSelectColumn: true,
            selected: buildingSelectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };

        const selectUnmappedRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleUnmappedSelect,
            hideSelectColumn: true,
            selected: unmappedSelectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };

        const unmappedColumns = [
            {
                text: 'Date Created',
                dataField: 'DateCreated',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '170px', textAlign: 'left' };
                }
            },
            {
                text: 'Service Call ID',
                dataField: 'ServiceCallID',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '150px' };
                }
            },
            {
                text: 'Location ID',
                dataField: 'LocationID',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Location Name',
                dataField: 'LocationName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Customer ID',
                dataField: 'CustomerID',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Customer Name',
                dataField: 'CustomerName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Address',
                dataField: 'Address1',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'State',
                dataField: 'State',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '80px', wordBreak: 'break-all' };
                }
            }];
        const selectRequestRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleRequestSelect,
            hideSelectColumn: true,
            selected: requestSelectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        return (
            <div>
                <Modal ref={this.confirmModal} show={showModal} onHide={this.handleClose} size='lg'>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Confirm Mapping</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Label>{this.state.modalText}</Form.Label>
                        <Form className="mobile-justify-left" as={Row} controlId="BuildingMappingForm" style={{ padding: '10px 10px 0px 10px', justifyContent: 'left' }}>
                            <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'left', padding: 20,fontSize:'24px', fontWeight: 'bold' }} column md={12}>
                                Mapping K2A Location
                            </Form.Label>
                           <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'left', padding: 20, fontWeight: 'bold' }} column md={12}>
                            </Form.Label>
                            <Form.Group as={Row} className="mb-12">
                                <Row>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'right', fontWeight:'bold', padding: 10 }} column md={3}>Customer Name</Form.Label>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'left', padding: 10 }} column md={8}>{this.state.location.CustomerName}</Form.Label>
                               </Row>
                                <Row>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'right', fontWeight: 'bold', padding: 10 }} column md={3}>Customer ID</Form.Label>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'left', padding: 10 }} column md={8}>{this.state.location.CustomerID}</Form.Label>
                                </Row>
                                <Row>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'right', fontWeight: 'bold', padding: 10 }} column md={3}>Location ID</Form.Label>
                                    <Form.Label style={{ alignSelf: 'center', textAlign: 'left', padding: 10 }} column md={8}>{this.state.location.LocationID}</Form.Label>
                                </Row>
                               <Row>
                                    <Col></Col>
                                    <Col md={4}><Form.Label style={{ alignSelf: 'center', textAlign: 'right', fontWeight:'bold'}}>K2A Location</Form.Label></Col>
                                    <Col md={4}><Form.Label style={{ alignSelf: 'center', textAlign: 'right', fontWeight:'bold'}}>Building</Form.Label></Col>
                                </Row>
                                <Row>
                                    <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Location Name</Form.Label>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.location.LocationName}   readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.SubmittedMapping_BuildingName}   readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                </Row>
                                <Row>
                                    <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Address</Form.Label>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.location.Address1} readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.SubmittedMapping_Address} readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                </Row>
                                <Row>
                                    <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>City</Form.Label>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.location.City} readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.SubmittedMapping_City}   readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                </Row>
                                <Row>
                                     <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>State</Form.Label>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.location.State} readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.SubmittedMapping_State}   readOnly={true} style={{ minWidth: "200px" }} /></Col>
                               </Row>
                                <Row>
                                    <Form.Label className="mobile-text-align-l mobile-p-l-10" style={{ alignSelf: 'center', textAlign: 'right', padding: 10 }} column md={3}>Zip</Form.Label>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.location.Zip} readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                    <Col md={4}><Form.Control type="input" placeholder={this.state.SubmittedMapping_Zip}   readOnly={true} style={{ minWidth: "200px" }} /></Col>
                                </Row>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="confirm" onClick={this.handleMapSubmit}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='consultationRequest' /> : <GuestSiteMenu currentPage='consultationRequest' />)}
                <table style={{ width: '100%' }}>
                    <tr>
                        <td>
                             <Form.Label style={{ padding: '10px', marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 28 }}>Manage Building Mapping</Form.Label>
                       </td>
                    </tr>
                    <tr>
                        <td style={{ verticalAlign: 'top', padding: '10px' }}>
                            <div style={{ border:'2px solid darkblue' }}>
                                <Row className="form-row-first" controlId="searchForm">
                                    <Col md="auto" sm="auto" xs="auto">
                                        <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>Search for Buildings</Form.Label>
                                    </Col>
                                </Row>
                                <Form onSubmit={this.handleSearch} noValidate style={{ border: '1px', maxWidth: '100%' }} >
                                    <Row className="form-row-first">
                                        <Col md={4}>
                                            <Form.Group className="mb-3" controlId="BuildingName" >
                                                <Form.Label>Building Name</Form.Label>
                                                <Form.Control type="input" name="BuildingName" value={this.state.search.BuildingName} onChange={this.handleFormChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group className="mb-3" controlId="CustomerID">
                                                <Form.Label>Customer ID</Form.Label>
                                                <Form.Control type="input" name="CustomerID" value={this.state.search.CustomerID} onChange={this.handleFormChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group className="mb-3" controlId="FormAddress">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control name="Address" value={this.state.search.Address} onChange={this.handleFormChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>
                                            <Form.Group className="mb-3" controlId="FormState">
                                                <Form.Label>State</Form.Label>
                                                <Form.Control name="State" value={this.state.search.State} onChange={this.handleFormChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>
                                            <Form.Group className="mb-3" controlId="FormZip">
                                                <Form.Label>Zip</Form.Label>
                                                <Form.Control name="Zip" value={this.state.search.Zip} onChange={this.handleFormChange} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="auto" sm="auto" xs="auto">
                                            <Form.Group className="mb-3" controlId="FormZip">
                                                <Button style={{ backgroundColor: '#00973A', marginLeft: '10px', marginTop: '0px', width: 'auto' }} variant="primary" type="submit">
                                                    Manual Search
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                        <Col md="auto" sm="auto" xs="auto">
                                            <Form.Group className="mb-3" controlId="FormZip">
                                                <Button style={{ backgroundColor: '#00973A', marginLeft: '10px', marginTop: '0px', width: 'auto' }} variant="primary" onClick={this.handleAutoMapping}>
                                                    Auto Mapping
                                                </Button>
                                            </Form.Group>
                                        </Col>
                                   </Row>
                                </Form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <BootstrapTable
                                bootstrap4
                                remote
                                keyField="DistinctId"
                                data={unmappedData}
                                columns={unmappedColumns}
                                selectRow={selectUnmappedRow}
                                striped
                                hover
                                noDataIndication={this.unmappedLoadingSpinner}
                                loading={this.state.unmappedLoading}
                                style={customStyle}
                                onTableChange={this.handleTableChange}
                            />
                        </td>
                    </tr>
                    <tr>
                        {/*<td style={{ padding: '10px', width: '50%', verticalAlign:'top' }}>*/}
                        {/*    <div style={{ border: '2px solid darkblue' }}>*/}
                        {/*        <Form onSubmit={this.handleSubmit} noValidate >*/}
                        {/*            <Row className="form-row-first" controlId="searchForm">*/}
                        {/*                <Col md="auto" sm="auto" xs="auto">*/}
                        {/*                    <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>K2A Location Details</Form.Label>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*            <Row className="form-row-secondary">*/}
                        {/*                <Col md>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formFirstname" >*/}
                        {/*                        <Form.Label>Customer ID</Form.Label>*/}
                        {/*                        <Form.Control disabled type="input" name="CustomerID" value={this.state.location.CustomerID} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*                <Col md>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formLastname">*/}
                        {/*                        <Form.Label>Address</Form.Label>*/}
                        {/*                        <Form.Control disabled type="input" name="Address1" value={this.state.location.Address1} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*            <Row className="form-row-secondary">*/}
                        {/*                <Col md>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formBasicEmail">*/}
                        {/*                        <Form.Label>Customer Name</Form.Label>*/}
                        {/*                        <Form.Control disabled name="CustomerName" value={this.state.location.CustomerName} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*                <Col md>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formPhoneNumber">*/}
                        {/*                        <Form.Label>City</Form.Label>*/}
                        {/*                        <Form.Control disabled name="City" value={this.state.location.City} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*            <Row className="form-row-secondary">*/}
                        {/*                <Col md={6}>*/}
                        {/*                    <Form.Group className="mb-3">*/}
                        {/*                        <Form.Label>Location ID</Form.Label>*/}
                        {/*                        <Form.Control disabled name="LocationID" value={this.state.location.LocationID} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*                <Col md={3}>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formPhoneNumber">*/}
                        {/*                        <Form.Label>State</Form.Label>*/}
                        {/*                        <Form.Control disabled name="State" value={this.state.location.State} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*                <Col md={3}>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formPhoneNumber">*/}
                        {/*                        <Form.Label>Zip</Form.Label>*/}
                        {/*                        <Form.Control disabled name="Zip" value={this.state.location.Zip} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*            <Row className="form-row-secondary">*/}
                        {/*                <Col md={6}>*/}
                        {/*                    <Form.Group className="mb-3" controlId="formPhoneNumber">*/}
                        {/*                        <Form.Label>Location Name</Form.Label>*/}
                        {/*                        <Form.Control disabled name="LocationName" value={this.state.location.LocationName} />*/}
                        {/*                    </Form.Group>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*            </Form>*/}
                        {/*    </div>*/}
                        {/*    <div style={{height:'12px' }}></div>*/}
                        {/*</td>*/}
                        <td style={{ verticalAlign: 'top', padding: '10px', paddingLeft:'0px', width: '50%' }}>
                            <div id="divBuildingList" style={{ border: '2px solid darkblue',height:'540px' }}>
                                <Row >
                                    <Col md>
                                            <Form.Label style={{ paddingLeft:'16px',paddingTop:'6px', verticalAlign: 'bottom', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>Building List</Form.Label>
                                    </Col>
                                </Row>
                                <Row >
                                    <Col md>
                                        <BootstrapTable
                                            striped
                                            bordered
                                            remote
                                            id="buildings"
                                            keyField="BuildingKey"
                                            wrapperClasses="table-responsive building_table"
                                            data={buildings}
                                            columns={buildingColumns}
                                            selectRow={selectBuildingRow}
                                            onTableChange={this.handleTableChange}
                                            noDataIndication={() => <Form.Label>No results found.</Form.Label>}
                                            hover
                                        />
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ height: '12px' }}></div>
                            {this.MapBuildingButton()}
                            {this.CreateBuildingDialog()}
                       </td>
                    </tr>
                </table>
            </div>
        );
    }
}

export default ManageBuildingLocation;